<template>
  <div>
    <b-notification :has-icon="true" icon="database" :closable="false">
      <span v-html="$t('compCarbonFormsRactivitiesHelpData.text-1')" />
      <ul style="list-style-type: square; margin-left: 25px">
        <li>
          <span v-html="$t('compCarbonFormsRactivitiesHelpData.text-2')" />
        </li>
        <li>
          <span v-html="$t('compCarbonFormsRactivitiesHelpData.text-3')" />
        </li>
        <li>
          <span v-html="$t('compCarbonFormsRactivitiesHelpData.text-4')" />
        </li>
        <li>
          <span v-html="$t('compCarbonFormsRactivitiesHelpData.text-5')" />
        </li>
      </ul>
    </b-notification>
  </div>
</template>

<script>
export default {
  name: 'HelpData'
}
</script>
